//1
let header =  document.querySelector(".header")

function setPadding(){
  let tempPadding = (innerWidth - 1200) * 1.1 / 2
 header.style.padding = tempPadding<0? "3rem 0":"0 "+tempPadding+"px"
}

  setPadding()


window.addEventListener("resize",e=>{
  if(innerWidth>1000){
      console.log(innerWidth)
  setPadding()
  }
  
})



//2 
let homeFlag =  document.querySelector(".oy-home")
let MainContent =  document.querySelector("#MainContent")
if(homeFlag){
  document.querySelector("html").classList.add("oy-home")
}



function setColor(){
  let scrollTop =  document.documentElement.scrollTop || document.body.scrollTop
  if(homeFlag){
         if(scrollTop>=50){
          if(!header.classList.contains("oy-active")){
            header.classList.add("oy-active")
          }
      }else{
          if(header.classList.contains("oy-active")){
            header.classList.remove("oy-active")
          }
      }
  }else{
       header.classList.add("oy-active")
        console.log(MainContent)
        MainContent.style.transform = `translateY(${header.offsetHeight-3}px)`
  }
 
}
  setColor()
window.addEventListener("scroll",e=>{
  setColor()
})




// //3


//   // 检测页面中是否存在 .oy-home 类名
//   if (document.querySelector('.oy-home')) {
//     // 动态加载指定的 CSS 文件
//     const cssUrl = '{{ 'add-oy-main.css' | asset_url }}';
//     const linkTag = document.createElement('link');
//     linkTag.rel = 'stylesheet';
//     linkTag.href = cssUrl;
//     document.head.appendChild(linkTag);
//   }
